<a href="mailto:{{ email }}">
  {{ email }}
</a>
